import { Component, Inject, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MatPaginator, MatTableDataSource, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Message } from 'src/app/core/class/message';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { CommonService } from 'src/app/core/services/common.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { ItemCategory } from 'src/app/shared/models/item-category.model';

@Component({
  selector: 'app-assign-group-customer-dialog',
  templateUrl: './assign-group-customer-dialog.component.html',
  styleUrls: ['./assign-group-customer-dialog.component.scss']
})
export class AssignGroupCustomerDialogComponent implements OnInit {
  inputGroupValue: string;
  inputCustomerValue: string;
  filteredGroupOptions = [];
  nzCheckLoadingGroup = false;
  selectedGroup = [];
  isFormChanging: boolean = false;
  searchControl: FormControl;
  columnDefinitions = [
    { def: "id", showMobile: true },
    { def: "name", showMobile: true },
    { def: "group", showMobile: true },
    { def: "certificateNo", showMobile: true },
    { def: "email", showMobile: true },
    { def: "action", showMobile: true },
  ];
  @ViewChild('suffixGroupInput', { static: false }) suffixGroupInput: any;
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  paginate: {
    currentPage: number,
    pageSize: number,
    totalRow: number,
    totalPage: number,
    totalPageArray: [],
    no: []
  };
  error = '';
  subscription: Subscription;
  displayedColumns: string[] = [];
  selectedCustomer = [];
  filterRow = ['stt', 'filterName','filterGroupName', 'filterCertificate', 'filterEmail', 'actionFilter']
  filterForm = {
    name: '',
    groupName: '',
    certificateNo: '',
    email: '',
  }
  isShowFilter: boolean = false;
  dataCount: number = 0
  groupRequired: boolean = false

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChildren('focusInput') focusInput;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  constructor(private customerService: CustomerService,
    public commonService: CommonService,
    private responsiveService: ResponsiveService,
    private toastr: ToastrService,
    private message: Message,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<AssignGroupCustomerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) {
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
    this.selectedCustomer = this.data.selectedCustomer;
    this.getDataCustomer();
  }

  ngOnInit() {
    this.onChangeGroupSignSearch('');
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
    // if (this.commonService.getIsLockedEnterprise()) {
    //   this.displayedColumns = this.columnDefinitions
    //     .filter(cd => (cd.def !== 'action' && cd.def !== 'status' && cd.def !== 'check'))
    //     .map(cd => cd.def);
    // }
  }

  openFilter() {
    this.isShowFilter = !this.isShowFilter;
    if (!this.isShowFilter) {
      this.filterForm = {
        name: '',
        groupName: '',
        certificateNo: '',
        email: '',
      }
      this.getDataCustomer();
    }
  }


  getDataCustomer() {
    let data = this.selectedCustomer.filter(item => {
      let filterGroup = true
      if(item.customerGroupNames && item.customerGroupNames.length){
        filterGroup = item.customerGroupNames.some(group => group.toLowerCase().includes(this.filterForm.groupName.trim().toLowerCase()))
      }else if(this.filterForm.groupName.trim()){
        filterGroup = false
      }
      if (item.name.toLowerCase().includes(this.filterForm.name.trim().toLowerCase() || '')
        && filterGroup
        && item.certificateNo.toLowerCase().includes(this.filterForm.certificateNo.trim().toLowerCase() || '')
        && (item.email && item.email.toLowerCase().includes(this.filterForm.email.trim().toLowerCase() || '') || !item.email)) {
        return item;
      }
    }) || []
    this.dataCount = data.length
    this.dataSource.data = data;
  }



  onChangeGroupSignSearch($event) {
    let groupIds = this.selectedGroup.map(item => item.id);
    const body = {
      keyword: this.inputGroupValue,
      groupCustomerIds: groupIds,
      page: 0,
      pageSize: 5
    }
    this.nzCheckLoadingGroup = true;
    this.customerService.filterGroupCustomer(body)
      .subscribe(result => {
        this.filteredGroupOptions = result.data.content;
        this.nzCheckLoadingGroup = false;
      }, error => {
        this.nzCheckLoadingGroup = false;
      });

  }

  autocompleteGroupSelected($event: any, model: any) {
    if ($event.isUserInput) {
      this.isFormChanging = true;
      this.selectedGroup.push(model);
      this.onChangeGroupSignSearch('')
    }
  }

  deleteGroup(index) {
    this.selectedGroup.splice(index, 1);
    this.groupRequired = true
  }

  onAssign() {
    let customerIds = this.selectedCustomer.map(item => item.id);
    let groupIds = this.selectedGroup.map(item => item.id);
    const body = {
      customerIds: customerIds,
      groupCustomerIds: groupIds
    }

    this.customerService.addCustomerToGroup(body).subscribe(res => {
      if (res && res.success) {
        this.toastr.success(this.message.getMessage('messages.add_to_group_success'));
        this.dialogRef.close(true)
      } else {
        this.toastr.error(res.message)
      }
    })
  }

  onRemoveAssign() {
    let customerIds = this.selectedCustomer.map(item => item.id);
    let groupIds = this.selectedGroup.map(item => item.id);
    const body = {
      customerIds: customerIds,
      groupCustomerIds: groupIds
    }

    this.customerService.deleteCustomerInGroup(body).subscribe(res => {
      if (res && res.success) {
        this.toastr.success(this.message.getMessage('messages.remove_assign_group_success'));
        this.dialogRef.close(true)
      } else {
        this.toastr.error(res.message)
      }
    })
  }

  onClose() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialog.closeAll()
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close()
    }
  }

  onClickIconDelete(customer) {
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_delete_customer_in_group'), customer.name)
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.selectedCustomer = this.selectedCustomer.filter(item => item.id !== customer.id);
        this.toastr.success(this.message.getMessage('messages.delete_customer_success'));
        this.getDataCustomer()
      }
    });
  }

  checkIndexOfElement(element){
    const index = this.dataSource.data.indexOf(element) + 1
    if((this.isShowFilter && index % 2 !== 0) || (!this.isShowFilter && index % 2 == 0)){
      return true
    }
    return false
  }
}
